

<template>
	<v-touch class="touch" v-bind:enabled="{pinch:true, touch:true, pan:true}" v-on:pinchmove="onPinchMove" v-on:pinchend="onPinchEnd" v-on:pressup="onTouchEnd" v-on:panstart="onPanStart" v-on:panmove="onPanMove">
		<div class="map">
			<figure @click="onClickMap" ref="imageContainer">
				<div ref="image" class="image" :style="style">
					<component v-if="!app.useMobileVersion" is="Button" v-for="(child, index) in children"
						:navClass="child.navClass"
						:x="child.position.x"
						:y="child.position.y"
						:align="child.position.align"
						:index="index"
						:key="child.url"
						:node="child"
						:link="getChildLink(child)">
							{{ child.name }}
					</component>
					<template v-for="(hotspot, index) in hotspots">
						<component v-if="hotspot.style == 'text'"
							is="HotspotButton"
							:key="`hs-${index}`"
							:x="hotspot.x"
							:y="hotspot.y"
							:align="hotspot.align || 'right'"
							:link="hotspot.article"
						>{{ hotspot.label || hotspot.subtitle }}</component>
						<component v-else 
							is="Hotspot"
							:key="`hs-${index}`"
							:x="hotspot.x"
							:y="hotspot.y"
							:link="hotspot.article"
						/>
					</template>
				</div>
			</figure>
		</div>
	</v-touch>
</template>

<script>

import Vue from 'vue'
import { EventBus } from '@/common/eventbus.js'
import { store } from '@/store'
import { mapState } from 'vuex'
import { Navigation } from '@/services/navigation.service'

var VueTouch = require('vue-touch')
Vue.use(VueTouch, {name: 'v-touch'})

export default {
	store,
	props: ['img', 'imgRatio', 'transform', 'children', 'hotspots', 'node'],
	data: () => {
		return {
			debug: true,
			top: 0,
			left: 0,
			width: 100,
			height: 200,
			momentum: false,
			panOptions: {
				direction: 'all',
				threshold: 40
			},
			touchOffset: {
				sx: 0,
				sy: 0,
				sscale: 1,
				x: 0,
				y: 0,
				scale: 1,
			}
		}
	},
	computed: {
		...mapState('globals', ['app']),
		...mapState('settings', ['presets']),
		style() {
			var css = {
				backgroundImage: `url(assets/maps/${this.img})`,
				top: `${this.top}px`,
				left: `${this.left}px`,
				width:`${this.width}px`,
				height:`${this.height}px`,
				transform: `scale(${this.touchOffset.scale}) translate(${this.touchOffset.x}px, ${this.touchOffset.y}px)`
			}
			return css;
		},
		offset() {
			return {
				x: 100/this.width * (this.width * this.transform.scale - this.width) * this.transform.x,
				y: 100/this.height * (this.height * this.transform.scale - this.height) * this.transform.y
			};
		}
	},

	mounted() {
		EventBus.$on('resizeWindow', this.updateImagePosition );
		this.updateImagePosition();
	},

	beforeDestroy() {
		EventBus.$off('resizeWindow', this.updateImagePosition );
	},

	methods: {
		resetTouchTransformations() {
			this.touchOffset.scale = 1;
			this.touchOffset.sscale = 1;
			this.touchOffset.x = 0;
			this.touchOffset.y = 0;
			this.width = 100;
			this.height = 200;
			this.top = 0;
			this.left = 0;
		},
		normalizePosition() {
			this.touchOffset.sscale = this.touchOffset.scale;
			var rect = this.$refs.image.getBoundingClientRect();
			this.resetTouchTransformations();
			this.left = rect.left;
			this.top = rect.top;
			this.width = rect.width;
			this.height = rect.height;
		},
		onTouchEnd( ev ) {
			this.normalizePosition();
		},
		onPinchEnd( ev ) {
			this.normalizePosition();
		},
		onPinchMove( ev ) {
			this.touchOffset.scale = this.touchOffset.sscale * ev.scale;
		},
		onPanStart( ev ) {
			this.touchOffset = Object.assign(this.touchOffset, {
				sx: this.touchOffset.x,
				sy: this.touchOffset.y,
			});
		},
		onPanMove( ev ) {
			this.touchOffset = Object.assign(this.touchOffset, {
				x: this.touchOffset.sx + ev.deltaX * (1/this.touchOffset.scale),
				y: this.touchOffset.sy + ev.deltaY * (1/this.touchOffset.scale),
			});
		},

		/**
		 * 	Fallback für Child-Position (falls nicht im navigation.json definiert)
		 *
		 */
		getChildLink( child ) {
			return child.link || child.url;
		},

		updateImagePosition () {

			this.resetTouchTransformations();
			var vw = this.$refs.imageContainer.offsetWidth;
			var vh = this.$refs.imageContainer.offsetHeight;

			var height = vw * 1/this.imgRatio;
			var width = vw;

			if (this.transform.cover) {
				if (height < vh) {
					height = vh;
					width = this.imgRatio * height;
				}
			} else {
				if (height > vh) {
					height = vh;
					width = this.imgRatio * height;
				}
			}

			var x = this.transform.x/100 * width;
			var y = this.transform.y/100 * height;

			width *= this.transform.scale;
			height *= this.transform.scale;

			this.width = width;
			this.height = height;

			this.left = (vw - width) / 2 + x;
			this.top = (vh - height) / 2 + y;
		},

		onClickMap( e ) {

			if (!this.debug || app.useMobileVersion) return;
			if (!e.metaKey && !e.altKey) return;

			var xp = this.round( 100 / this.width * (e.clientX - this.left) );
			var yp = this.round( 100 / this.height * (e.clientY - this.top) );

			if (e.metaKey) {
				this.hotspots.pop();
				console.log(`{x:${xp}, y:${yp}, article:'xxx'},`);
				return this.hotspots.push({x:xp, y:yp});
			}
			this.children.pop();
			var align = e.shiftKey ? 'left' : 'right';
			console.log(`position: {x:${xp}, y:${yp}, align:${align}}`);
			return this.children.push({path:'x', name:'Neu', position:{x:xp, y:yp, align:align}, children:[]});
		},

		round( n ) {
			return Math.floor(n*100)/100;
		}
	}

}
</script>

<style scoped lang="scss">
	.touch {
		@include position( absolute, 0 0 40% 0 );
		@media ($min-device-width-sm) {
			@include position( absolute, 0 0 0 0 );
		}
	}
	map,
	figure {
		@include position( absolute, 0 0 0 0 );
	}
	.image {
		position: absolute;
		background: transparent none center center no-repeat;
		background-size: cover;
	}
</style>
